import './style.scss';

import React, { useEffect, useState, useCallback, useRef } from 'react';
import { connect } from 'react-redux';

import { updateHasEnrollmentCampaign, updatePlan, updateFeatures, updateChangeSupportAccess } from 'actions';

import { exitSupportAccess, getEnrollmentCampaignStatus, withRouterAndRef } from 'services/utils';
import useNotificationCampaigns from 'pctHooks/useNotificationCampaigns';
import PctUpgrade from '../PctUpgrade';
import PctPlanContract from '../PctPlanContract';

import HeaderMenuPrincipal from './components/HeaderMenuPrincipal';
import HeaderContentNavigation from './components/HeaderContentNavigation';
import HeaderDropdownMenu from './components/HeaderDropdownMenu';
import HeaderSearchBox from './components/HeaderSearchBox';
import HeaderLogo from './components/HeaderLogo';
import HeadeNavControlls from './components/HeadeNavControlls';
import HeaderToast from './components/HeaderToast';
import HeaderNotification from './components/HeaderNotification';
import HeaderLesson from './components/HeaderLesson';
import { OriginNavigation } from 'pctComponents/organisms/ManagerTrial/@model/ManagerTrial.model';
import usePlan from 'pctHooks/usePlan';
import { getMenuData, isAuthenticated, renewlogin } from 'services/api';
import { useHistory } from 'react-router-dom';

const PctHeader = (props) => {
    const { updatePlan, planUpgrade, supportAccessChangeStatus } = props;
    const { getActivePlanData, openModalUpgrade, triggerCallBackInterval } = usePlan();
    const [scrolling, setScrolling] = useState(false);
    const [homeScreenStatus, setScreenStatus] = useState(false);
    const [headerStyleContainer, headerStyleStatus] = useState({});
    const [campaign, setCampaign] = useState(null);
    const [searchOpen, setSearchOpen] = useState(false);
    const [activePlan, setActivePlan] = useState(undefined);
    const [scoSingleContent, setScoSingleContent] = useState(null);

    const [menuComponentKey, setMenuComponentKey] = useState(0);
    const didMount = useRef(false);
    const history = useHistory();

    const init = useCallback((activePlanData) => {
        setActivePlan(activePlanData);

        if (activePlanData?.userIsAdmin) {
            triggerCallBackInterval(activePlanData, () =>
                openModalUpgrade({
                    hasRequestedUpgrade: false,
                    userIsAdmin: activePlanData.userIsAdmin,
                    numberRequest: 0,
                    originNavigation: OriginNavigation.header,
                }),
            );
        } else if (activePlanData && activePlanData.deadline <= 0) {
            triggerCallBackInterval(activePlanData, () =>
                openModalUpgrade({
                    hasRequestedUpgrade: false,
                    userIsAdmin: activePlanData.userIsAdmin,
                    numberRequest: 0,
                    originNavigation: OriginNavigation.header,
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getNavigationEntry = () => {
        if (typeof performance !== 'undefined' && performance.getEntriesByType) {
            const [entry] = performance.getEntriesByType('navigation');
            return entry || null;
        }
        return null;
    };

    useEffect(() => {
        let mounted = true;

        (async () => {
            try {
                const navigationEntry = getNavigationEntry();

                if (navigationEntry && navigationEntry.type !== 'reload') {
                    const { accessSupport } = getMenuData().loginInfo;

                    if (accessSupport) {
                        await exitSupportAccess({
                            handleExitSupportAccess: () => {
                                updateChangeSupportAccess();
                                history.push('/');
                            },
                        });
                        return;
                    }
                }

                const data = await getActivePlanData();

                if (!mounted) {
                    return;
                }

                if (data?.trial && data?.userIsAdmin) {
                    openModalUpgrade({
                        hasRequestedUpgrade: false,
                        userIsAdmin: data.userIsAdmin,
                        numberRequest: 0,
                        originNavigation: OriginNavigation.header,
                    });
                }

                init(data);
            } catch (err) {
                console.error(err);
            }
        })();

        return () => {
            mounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [init, history, updateChangeSupportAccess]);

    const utilsEnrollmentCampaignStatusApi = useCallback(() => {
        getEnrollmentCampaignStatus()
            .then((res) => {
                props.updateHasEnrollmentCampaign({
                    userIsInCampaign: res?.[0]?.data?.userIsInCampaign ?? false,
                    hasEnrollmentRequests: res?.[1]?.data?.hasEnrollmentRequests ?? false,
                });
                props.updateFeatures({
                    externalcourses: res?.[2]?.data?.active ?? false,
                });
                setMenuComponentKey((prev) => prev + 1);
            })
            .catch(() => {
                props.updateHasEnrollmentCampaign({
                    userIsInCampaign: false,
                    hasEnrollmentRequests: false,
                });
                props.updateFeatures({ externalcourses: false });
                setMenuComponentKey((prev) => prev + 1);
            });
    }, [props]);

    useEffect(() => {
        const path = props.location?.pathname;
        setScreenStatus(path === '/' || path === '/home');

        headerStyleStatus(props.configHeaderFooter);
        setCampaign(props.configCampaign);

        if (props.configHeaderFooter?.scoSingle === true) {
            setScoSingleContent(props.configHeaderFooter?.contentNavigation?.content ?? null);
        } else if (props.configHeaderFooter?.scoSingle === false) {
            setScoSingleContent(null);
        }
    }, [props]);

    useEffect(() => {
        utilsEnrollmentCampaignStatusApi();

        const navigationEntry = getNavigationEntry();
        if (navigationEntry && isAuthenticated()) {
            ///Verificar que não esta como Acesso de Support
            const { accessSupport } = getMenuData().loginInfo;
            if (!accessSupport) {
                renewlogin();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (didMount.current && supportAccessChangeStatus) {
            utilsEnrollmentCampaignStatusApi();
        } else {
            didMount.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [supportAccessChangeStatus]);

    window.addEventListener('scroll', (e) => {
        const window = e.currentTarget;
        let currentPosition = window.scrollY;
        currentPosition > 50 ? setScrolling(true) : setScrolling(false);
    });

    useNotificationCampaigns({ props, setCampaign });

    const {
        headerStyle,
        prevNavStyle,
        logoStyle,
        tituloStyle,
        perfilUsuarioStyle,
        perfilStyle,
        menuStyle,
        titleHeader,
        closeFn,
        nodeCollection,
        backCloseText,
    } = headerStyleContainer;

    return (
        <>
            {headerStyle !== 'hide' ? (
                <header
                    className={`pctOrganism pctHeader ${headerStyle} ${scrolling ? 'active' : ''} ${
                        props.configHeaderFooter.contentNavigation ? 'contentView' : ''
                    }`}
                    key={menuComponentKey}
                >
                    <div className="leftHeader">
                        <HeaderMenuPrincipal
                            menuStyle={menuStyle}
                            hasEnrollmentRequests={props.configHasEnrollmentCampaign?.hasEnrollmentRequests}
                            userIsInCampaign={props.configHasEnrollmentCampaign?.userIsInCampaign}
                            externalcourses={props.configFeatures?.externalcourses}
                        />

                        <HeadeNavControlls
                            prevNavStyle={prevNavStyle}
                            closeFn={closeFn}
                            navHistory={props.history}
                            backCloseText={backCloseText}
                            nodeCollection={nodeCollection}
                            updatePlan={updatePlan}
                            planUpgrade={props.planUpgrade}
                            configHeaderFooter={props.configHeaderFooter}
                        />
                    </div>

                    <HeaderLogo
                        searchOpen={searchOpen}
                        logoStyle={logoStyle}
                        homeScreenStatus={homeScreenStatus}
                        tituloStyle={tituloStyle}
                        titleHeader={titleHeader}
                        isUpgradeButtonActive={props.planUpgrade.isUpgradeButtonActive}
                    />

                    <div className="rightHeader">
                        <div className="rigthRow">
                            {!activePlan ? (
                                <PctUpgrade
                                    hide={searchOpen}
                                    updatePlan={updatePlan}
                                    isUpgradeButtonActive={props.planUpgrade.isUpgradeButtonActive}
                                    {...props.planUpgrade}
                                />
                            ) : (
                                <PctPlanContract
                                    hide={searchOpen}
                                    {...activePlan}
                                    planUpgrade={planUpgrade}
                                    updatePlan={updatePlan}
                                    planUpgradeProp={props.planUpgrade}
                                />
                            )}

                            <div className={`itensR ${searchOpen && 'open'}`}>
                                <HeaderSearchBox searchOpen={searchOpen} setSearchOpen={setSearchOpen} />

                                <HeaderDropdownMenu
                                    perfilUsuarioStyle={perfilUsuarioStyle}
                                    hasEnrollmentRequests={props.configHasEnrollmentCampaign?.hasEnrollmentRequests}
                                    userIsInCampaign={props.configHasEnrollmentCampaign?.userIsInCampaign}
                                    externalcourses={props.configFeatures?.externalcourses}
                                />

                                <HeaderNotification perfilStyle={perfilStyle} />
                            </div>
                        </div>

                        <HeaderContentNavigation
                            nodeCollection={nodeCollection}
                            configHeaderFooter={props.configHeaderFooter}
                            scoSingleContent={scoSingleContent}
                        />
                        <HeaderLesson lessonHeader={props.configHeaderFooter.lessonHeader} />
                    </div>
                </header>
            ) : null}

            <HeaderToast campaign={campaign} />
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    updateHasEnrollmentCampaign: (item) => dispatch(updateHasEnrollmentCampaign(item)),
    updatePlan: (item) => dispatch(updatePlan(item)),
    updateFeatures: (item) => dispatch(updateFeatures(item)),
});

const mapStateToProps = (store) => ({
    currentContentType: store.contentState.currentContentType,
    configHeaderFooter: store.configHeaderFooterState.configHeaderFooter,
    configCampaign: store.configCampaignState.configCampaign,
    configHasEnrollmentCampaign: store.hasEnrollmentCampaignState.configHasEnrollmentCampaign,
    planUpgrade: store.planUpgrade,
    apiReplication: store.apiReplicationState,
    configFeatures: store.configFeaturesState.configFeatures,
    supportAccessChangeStatus: store.supportAccessState,
});

export default withRouterAndRef(connect(mapStateToProps, mapDispatchToProps)(PctHeader));
